<template>
  <!-- Row: Chart -->
  <div :id="'div' + divName" class="row f-row table_chart_height mt-1 w-100">
    <div class="row f-row" style="height:100%; width:100%;">
      <div class="col col-12 h-100">
        <div
          class="col col-12 text-center"
          v-if="!loadingAll && zoomedData.length === 0"
          style="width: 100%; top: 40px!important; position: absolute;"
        >
          {{ noDataStr }}
        </div>
        <div
          v-else-if="zoomedData.length > 0"
          class="container__table-borderless"
          :style="{ 'padding-right': (isLarge ? 45 : 55) + 'px!important' }"
          style="padding-left: 1px"
        >
          <table
            class="table table-sm table-borderless curve_analysis_table"
            :class="isTotals && 'table__totals'"
          >
            <thead class="table-headers text-center align-center thead">
              <tr v-if="!isLarge">
                <th
                  :style="{
                    width: `${Math.round(
                      !isLarge ? divWidth / 12 : (4 * divWidth) / 12,
                    )}px !important`,
                  }"
                >
                  Date range
                </th>
                <td>
                  {{ dateValue }}
                </td>
              </tr>
              <tr
                v-for="(dat, idx) in tableFormat"
                v-bind:key="idx"
                :class="{
                  'div-prices': dat.divP,
                  'div-quantity': dat.divQ,
                }"
              >
                <template v-if="!dat.isDetails || showDetails">
                  <th
                    :class="{
                      ['background_ok']: dat.divP,
                      ['text__prices' + divName]:
                        tableFormat.some((d) => d.divP) && idx === 0,
                      ['text__quantities' + divName]:
                        idx === tableFormat.length - 1,
                    }"
                    :style="widthTh()"
                  >
                    {{ dat.label }}
                    <template
                      v-if="formatVars.hiddenLabel.includes(dat.label)"
                    ></template>
                    <template v-else-if="dat.isPrices == null">
                      ({{ dat.sUnit }})
                    </template>
                    <template v-else-if="dat.isPrices">
                      {{ isCurrency ? "Rate" : "Pr" }}
                      <span v-if="isAdvanced && isCurrency"
                        >({{ `${dat.unit}/${dat.sUnit}` }})</span
                      ><span v-if="isAdvanced && !isCurrency"
                        >({{ `${dat.sUnit}/${dat.unit}` }})</span
                      >
                    </template>
                    <template v-else>
                      Qty <span v-if="isAdvanced">({{ dat["unit"] }})</span>
                    </template>
                  </th>
                  <td
                    v-for="(item, index) in zoomedData"
                    v-bind:key="item.id || index"
                    :class="{
                      tableHovered:
                        (formatVars['userHovered']['date'] === +item.date &&
                          formatVars['userHovered']['variable'] ===
                            dat['elementNameTable'] &&
                          formatVars['userHovered']['hovered']) ||
                        (formatVars['userHovered']['fromChart'] &&
                          formatVars['userHovered']['date'] === +item.date &&
                          (dat['elementNameTable'].startsWith(
                            formatVars['userHovered']['variable'],
                          ) ||
                            (formatVars.elementsPLAN.includes(
                              dat['elementNameTable'],
                            ) &&
                              formatVars['userHovered']['variable'] ===
                                'RATE'))),
                    }"
                    :style="{
                      'background-color': dat['colorBckTable'],
                      'border-bottom': '1px solid ' + dat['colorBdr'],
                    }"
                    @mouseover="onTableHover(dat, item, true, index)"
                    @mouseleave="onTableHover(dat, item, false, index)"
                  >
                    <span>
                      {{ formatItem(item, dat) }}
                    </span>
                    <span v-if="zoomedData.length < 16 && dat.addLabel">
                      ({{ !item ? "-" : formatPercentSm(item[dat.unitPerc]) }})
                    </span>
                  </td>
                </template>
              </tr>
            </thead>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defaultAnalytics } from "@/_core/data/Analytics/AnalyticsHelpers.js";
import { formatPercentSm } from "@/_core/_helpers/_parametric_tools";
import { select } from "d3";

export default {
  name: "CommodityAdvancedTable",
  props: {
    Analytics: { required: true, default: defaultAnalytics() },
    colorTheme: { required: true, type: Boolean, default: true },
    divName: { required: false, default: "table" },
    formatVar: {
      default: {
        userHovered: {
          date: "",
          variable: "",
          hovered: false,
          fromChart: false,
        },
      },
    },
    isAdvanced: { required: false, type: Boolean, default: true },
    isLarge: { required: false, type: Boolean, default: true },
    isPast: { required: false, type: Boolean, default: false },
    isTotals: { required: false, type: Boolean, default: false },
    loadingAll: { required: true, type: Boolean, default: false },
    noDataStr: { required: false, type: String },
    renderChartSignal: { required: true, default: 0 },
    showDetails: { required: true, type: Boolean, default: false },
    tableFormat: { required: true, type: Array, default: () => [] },
    zoomedData: { required: true, default: () => [] },
  },
  components: {},
  data() {
    return {
      divWidth: 100,
      formatPercentSm: formatPercentSm,
      formatVars: {
        userHovered: {
          date: "",
          variable: "",
          hovered: false,
          fromChart: false,
        },
        hiddenLabel: [],
        elementsPLAN: [
          "DLF",
          "DSF",
          "DLC",
          "DLCKO",
          "DSC",
          "DSCKO",
          "DLP",
          "DLPKO",
          "DSP",
          "DSPKO",
          "lCallKO",
          "sCallKO",
          "lPutKO",
          "sPutKO",
        ],
      },
      regex: /\||%/,
    };
  },
  computed: {
    dateValue() {
      return this.zoomedData[0] != null
        ? Object.keys(this.zoomedData[0]).indexOf("date") !== -1
          ? this.zoomedData[0]["date"]
          : "date"
        : "...";
    },
    isCurrency() {
      return this.Analytics?.assetType === "currency";
    },
  },
  mounted() {
    this.calculateDivWidth();
  },
  watch: {
    renderChartSignal() {
      this.calculateDivWidth();
    },
    formatVar: {
      handler(newVal) {
        this.getChangeTableHover(newVal);
      },
      deep: true,
    },
  },
  methods: {
    // formatPercent(val) {
    //   return format(",.1%")(val).replace(".0%", "%");
    // },
    calculateDivWidth() {
      let element = document.getElementById("div" + this.divName);
      if (element != null) {
        Object.assign(this, {
          divWidth: element?.clientWidth,
        });
        const { textP, textQ, topP, topQ, leftP, leftQ } = this.getTextValues(
          this.tableFormat.length,
        );

        this.generateTextStyle(
          textP,
          `text__prices${this.divName}`,
          topP,
          leftP,
        );
        this.generateTextStyle(
          textQ,
          `text__quantities${this.divName}`,
          topQ,
          leftQ,
        );
      }
    },
    formatItem(item, dat) {
      if (Number.isNaN(item[dat.nameData]) || item[dat.nameData] == undefined) {
        return "-";
      } else {
        return dat.format(item[dat.nameData]); // .formatF(item[dat.nameData]);
      }
    },
    widthTh() {
      return {
        width: `${
          !this.isPast ? (3 * this.divWidth) / 12 - 10 : this.divWidth / 12 - 10
        }px !important`,
        "text-align": this.isAdvanced ? "right!important;" : "left!important;",
      };
    },
    getTextValues(tableFormatLength) {
      const textInfo = {
        short: {
          textP: "Px",
          textQ: "Qty",
          topP: 0,
          topQ: 25,
          leftP: 10,
          leftQ: 10,
        },
        long: {
          textP: "Prices",
          textQ: "Quantities",
          topP: 50,
          topQ: -70,
          leftP: 10,
          leftQ: 20,
        },
      };

      return tableFormatLength < 3 ? textInfo.short : textInfo.long;
    },
    generateTextStyle(content, selector, top, left) {
      const styleCSS = document.createElement("style");
      const divContainerTable = select(".curve_analysis_table").node();

      const divContainerTableWidth = divContainerTable
        ? divContainerTable.clientWidth
        : "";
      let divContainerTableTotalsWidth;
      if (this.isTotals) {
        const divContainerTableTotals = select(
          ".curve_analysis_table.table__totals",
        ).node();

        divContainerTableTotalsWidth = divContainerTableTotals
          ? divContainerTableTotals.clientWidth
          : "";
      }

      styleCSS.innerHTML = `
        .${selector} {
          position: relative;
        }
        th.${selector}::after {
          content: "${content}";
          position: absolute;
          transform: rotate(-90deg);
          top: ${top}%;
          transform-origin: center;
          white-space: nowrap;
          font-size: 12px;
          color: var(--white-gray);
          z-index: 1;
          text-shadow: 1px 1px 1px rgb(180 180 180 / 20%);
        }
        th#date-range::after {
          content: "${content}";
          position: absolute;
          transform: rotate(-90deg);
          top: ${top}%;
          left: ${this.divWidth / 12}px;
          transform-origin: center;
          white-space: nowrap;
          font-size: 12px;
          color: var(--white-gray);
          z-index: 1;
          text-shadow: 1px 1px 1px rgb(180 180 180 / 20%);
        }
        .curve_analysis_table thead tr th.${selector}::after {
          left: calc(${divContainerTableWidth}px - ${left}px) !important;
        }
        .curve_analysis_table.table__totals thead tr th.${selector}::after {
          left: calc(${divContainerTableTotalsWidth}px - ${left}px) !important;
        }
    `;

      document.head.appendChild(styleCSS);
    },
    onTableHover(dat, item, isHovered) {
      select(`.bar${dat["elementNameTable"]}${+item.date}`).classed(
        "hoved",
        isHovered,
      );
      select(
        `.${dat["figureElements"]}${dat["elementNameTable"]}${+item.date}`,
      ).classed("hoved", isHovered);

      select(`.${dat["elementNameTable"]}${+item.date}`).classed(
        "hoved",
        isHovered,
      );
      Object.assign(this.formatVars, {
        userHovered: {
          date: +item.date,
          variable: dat["elementNameTable"],
          hovered: isHovered,
          fromChart: false,
        },
      });
    },
    getDynamicInfoPrices(d) {
      let newNameData = "";
      let fldForecast = this.Analytics["userSelections"]["fldBudget"];
      let fldFixed = this.Analytics["userSelections"]["fldFixed"];
      let fldMkt = this.Analytics["userSelections"]["fldMkt"];
      let fldNet = this.Analytics["userSelections"]["fldNet"];
      if (d === "p_forecast" && fldForecast.includes("budgetP")) {
        newNameData = fldForecast;
      }
      if (d === "p_fixed" && fldFixed.includes("fixedP")) {
        newNameData = fldFixed;
      }
      if (d === "p_market" && fldMkt.includes("marketP")) {
        newNameData = fldMkt;
      }
      if (d === "p_net" && fldNet.includes("netP")) {
        newNameData = fldNet;
      }
      return newNameData;
    },
    getChangeTableHover(val) {
      Object.assign(this.formatVars, {
        userHovered: {
          date: val.date,
          variable: val.variable,
          hovered: false,
          fromChart: val.fromChart,
        },
      });
    },
  },
};
</script>

<style scoped>
.background_ok {
  background: var(--lightbackground-alpha) !important;
}
</style>
